// @ts-nocheck

import React, { useCallback } from 'react';
import styled from 'styled-components';

import { RedirectServices, getRedirectUrl } from '../../../../config/urls';
import { __ } from '../../../../i18n/l10n';

const StyledButton = styled.button`
  color: #fff;
  padding: 0;
  padding-bottom: 0.1em;
  border-bottom: solid 1px #fff;
  display: block;
  margin: 0.6em auto;
`;

type GridsRulesButtonProps = {
  openExternalLink: (url: string) => void;
};

const GridsRulesButton = ({ openExternalLink }: GridsRulesButtonProps) => {
  const handleOpenRules = useCallback(() => {
    openExternalLink(getRedirectUrl(RedirectServices.GRIDS_RULES));
  }, [openExternalLink]);

  return <StyledButton onClick={handleOpenRules}>{__('Rules')}</StyledButton>;
};

export default GridsRulesButton;
